import * as XLSX from 'xlsx';

/**
 * Export data to Excel file with multiple sheets.
 * @param {Array<{data: Array<Object>, name: string}>} sheets
 * @param {string} filename  (without .xlsx)
 */
export const exportToExcel = (sheets, filename) => {
  const wb = XLSX.utils.book_new();
  sheets.forEach(({ data, name }) => {
    const ws = XLSX.utils.json_to_sheet(data.length > 0 ? data : [{}]);
    if (data.length > 0) {
      const cols = Object.keys(data[0]).map((key) => ({
        wch: Math.max(key.length, ...data.map((r) => String(r[key] ?? '').length)) + 2,
      }));
      ws['!cols'] = cols;
    }
    XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31));
  });
  XLSX.writeFile(wb, `${filename}.xlsx`);
};
